import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { Winner } from 'model/winner';

@Injectable()
export class WinnerService {
    private deleted: number[] = [];
    private added: number[] = [];
    
    constructor(private api: ApiService) {

    }
    
    addTempDeleted(id: number) {
        this.deleted.push(id);

        setTimeout(() => {
            this.deleted = this.deleted.filter(x => x != id);
        }, 3000);
    }

    hasDeleted(id: number) {
        return this.deleted.find(x => x == id);
    }

    addTempAdded(id: number) {
        this.added.push(id);

        setTimeout(() => {
            this.added = this.added.filter(x => x != id);
        }, 3000);
    }

    hasAdded(id: number) {
        return this.added.find(x => x == id);
    }

    addWinner(winner: Winner) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.rodeoEvents + '/addWinner', winner)
                .then(data => resolve(data), error => reject(error));
        });
    }

    addWinners(winners: Winner[]) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.rodeoEvents + '/addWinners', winners)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteWinner(winnerId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .deleteWithAuth(this.api.endpoints.rodeoEvents + '/deleteWinner?id=' + winnerId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteWinners(winnerIds: number[]) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.rodeoEvents + '/deleteWinners', winnerIds)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getUpdatedEventWinners(rodeoId: number, currentWinners) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.rodeoEvents + '/getUpdatedWinners?rodeoId=' + rodeoId, currentWinners)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/winner.service.ts